export default __webpack_public_path__ + "static/media/CRToroClosed.c1ef5a99.jpg";